import { ColumnsType } from 'antd/es/table'
import { SortOrder } from 'antd/es/table/interface'
import { Sorter } from 'components/Sorter/Sorter'
import { Status, STATUS_TYPES_CLASSNAMES } from 'components/Status'
import { Link } from '../../../components/Link'
import { routes } from '../../../router'
import { ICCHealthSystemWithHospitals } from './types'
import { currencyFormatter } from '../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { ReactComponent as Information16 } from 'assets/svg/Information.svg'

export const columns = (
  canSeeExpectedValues: boolean,
  canSeeHealthSystem: boolean
) => {
  let columns: ColumnsType<ICCHealthSystemWithHospitals> = [
    {
      dataIndex: 'name',
      key: 'name',
      className: 'name-column',
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<ICCHealthSystemWithHospitals>
          dataIndex="name"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          {canSeeHealthSystem ? 'Health system' : 'Hospital'}
        </Sorter>
      ),
      render: (_, { name, uuid, hospital_level }) => (
        <>
          {hospital_level ? (
            <span className="name-column">{name}</span>
          ) : (
            <Link
              to={`${routes.myCommunity}${routes.healthSystem}/${uuid}`}
              className="name-column"
            >
              {name}
            </Link>
          )}
        </>
      ),
      sorter: true,
      showSorterTooltip: false
    }
  ]
  if (canSeeExpectedValues) {
    columns = columns.concat([
      {
        dataIndex: 'expected_spend',
        key: 'expected_spend',
        title: ({ sortOrder, sortColumn }) => (
          <Sorter<ICCHealthSystemWithHospitals>
            dataIndex="expected_spend"
            sortColumn={sortColumn}
            sortOrder={sortOrder as SortOrder}
          >
            <Tooltip title="Historical spend for this facility within this contract category">
              <div className="row gap-8">
                Expected spend, $
                <Information16 />
              </div>
            </Tooltip>
          </Sorter>
        ),
        render: (_, { expected_spend }) =>
          expected_spend ? currencyFormatter(expected_spend) : '-',
        sorter: true,
        showSorterTooltip: false
      },
      {
        dataIndex: 'expected_savings',
        key: 'expected_savings',
        title: ({ sortOrder, sortColumn }) => (
          <Sorter<ICCHealthSystemWithHospitals>
            dataIndex="expected_savings"
            sortColumn={sortColumn}
            sortOrder={sortOrder as SortOrder}
          >
            <Tooltip title="Projected savings for this facility in this contract category">
              <div className="row gap-8">
                Expected savings, $
                <Information16 />
              </div>
            </Tooltip>
          </Sorter>
        ),
        render: (_, { expected_savings }) =>
          expected_savings ? currencyFormatter(expected_savings) : '-',
        sorter: true,
        showSorterTooltip: false
      }
    ])
  }
  columns.push({
    dataIndex: 'name',
    key: 'name',
    title: null,
    width: 120,
    render: (_, { hospital_level, children }) => (
      <div className="flex justify-end">
        {!hospital_level && (
          <Status.Default className={STATUS_TYPES_CLASSNAMES.GRAY}>
            {`${children.length} Hospital${children.length === 1 ? '' : 's'}`}
          </Status.Default>
        )}
      </div>
    )
  })
  return columns
}
